import { gql } from '@apollo/client';

const SUBMIT_RETURN = gql`
  query orderReturn($returnDetails: OrderReturnDetails) {
    orderReturn(returnDetails: $returnDetails) {
      exchangeOrderId
      returnOrderId
    }
  }
`;

export default SUBMIT_RETURN;
